import { render, staticRenderFns } from "./run-status.vue?vue&type=template&id=009cc067"
import script from "./run-status.vue?vue&type=script&lang=js"
export * from "./run-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('009cc067')) {
      api.createRecord('009cc067', component.options)
    } else {
      api.reload('009cc067', component.options)
    }
    module.hot.accept("./run-status.vue?vue&type=template&id=009cc067", function () {
      api.rerender('009cc067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/physical-model/run-status.vue"
export default component.exports